/* eslint-disable react-hooks/exhaustive-deps */
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AppRadio from '../../components/AppRadio';
import PayIcon from '../../components/PayIcon';
import { getFullPicture } from '../../modules/imageHandler';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Pse from '../../assets/images/pse.png';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import AppButton from '../../components/AppButton';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import theme from '../../modules/theme';
import { useDispatch, useSelector } from 'react-redux';
import {
  SELECTOR_CREDIT_CARD_SELECTED,
  SELECTOR_CREDIT_CARDS,
} from '../../redux/selectors/creditCards';
import {
  getMyCreditCards,
  setCreditCardSelected,
} from '../../redux/actions/creditCards';
import CreditCardDialog from '../../components/CreditCardDialog';
import { getBanks } from '../../redux/actions/banks';
import { SELECTOR_BANKS } from '../../redux/selectors/banks';
import { addNotification } from '../../redux/actions/notifications';
import api from '../../services/api';
import { SELECTOR_USER } from '../../redux/selectors/auth';
import {
  getCustomPayments,
  getEWallet,
  getTotalEWallet,
} from '../../redux/actions/eWallet';

const useStylesViewPaymentMethodPSE = makeStyles({
  formControl: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
});

function ViewPaymentMethodPSE({ PSE, setPSE }) {
  const banks = useSelector(SELECTOR_BANKS);

  const classes = useStylesViewPaymentMethodPSE();
  const dispatch = useDispatch();

  function handleChange(event) {
    setPSE({
      ...PSE,
      [event.target.name]: event.target.value,
    });
  }

  useEffect(() => {
    dispatch(getBanks());
  }, []);

  return (
    <Box ml={3} my={1}>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Banco</Typography>
        <Select
          name="bank"
          margin="dense"
          value={PSE.bank}
          onChange={handleChange}
          label="Age"
        >
          {banks.map((item) => (
            <MenuItem value={item.bankCode}>{item.bankName}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Tipo de identificación</Typography>
        <Select
          labelId="type"
          id="type"
          name="type"
          margin="dense"
          className={classes.textField}
          value={PSE.type}
          onChange={handleChange}
        >
          {['CC', 'CE', 'PPN', 'SSN', 'LIC', 'NIT', 'DNI'].map((value) => (
            <MenuItem value={value} key={value}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Numero de identificación</Typography>
        <TextField
          variant="outlined"
          name="dni"
          value={PSE.dni}
          onChange={handleChange}
          className={classes.textField}
          margin="dense"
        />
      </FormControl>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Numero de teléfono</Typography>
        <TextField
          variant="outlined"
          name="cell_phone"
          value={PSE.cell_phone}
          onChange={handleChange}
          className={classes.textField}
          margin="dense"
        />
      </FormControl>
    </Box>
  );
}

const useStylesViewPaymentMethodCreditCards = makeStyles({
  addedButton: {
    fontWeight: 400,
  },
});

function ViewPaymentMethodCreditCards() {
  const selected = useSelector(SELECTOR_CREDIT_CARD_SELECTED);
  const creditCards = useSelector(SELECTOR_CREDIT_CARDS);

  const [open, setOpen] = useState(false);

  const classes = useStylesViewPaymentMethodCreditCards();
  const dispatch = useDispatch();

  function handleChange(e) {
    dispatch(setCreditCardSelected(Number(e.target.value)));
  }

  useEffect(() => {
    dispatch(getMyCreditCards());
    return () => {
      dispatch(setCreditCardSelected(0));
    };
  }, []);

  return (
    <Box ml={3}>
      <CreditCardDialog open={open} handleClose={() => setOpen(false)} />
      {creditCards.map((card) => (
        <RadioGroup
          key={card.id}
          aria-label="payment-method"
          name="payment"
          onChange={handleChange}
        >
          <FormControlLabel
            checked={selected === card.id}
            value={card.id}
            control={<AppRadio color="default" />}
            label={
              <Box display="flex" alignItems="center">
                <img
                  width={64}
                  height={40}
                  src={getFullPicture(
                    `logos-tarjetas-de-credito/${card.brand}.png`,
                  )}
                  alt={`logos-tarjetas-de-credito/${card.brand}.png`}
                />
                {card.masked_number}
              </Box>
            }
          />
        </RadioGroup>
      ))}
      <Button
        onClick={() => setOpen(true)}
        color="primary"
        startIcon={<AddIcon />}
        className={classes.addedButton}
      >
        Añadir nueva tarjeta
      </Button>
    </Box>
  );
}

const useStyles = makeStyles({
  subtitle: {
    fontSize: '1rem',
    fontWeight: 600,
  },
  addedButton: {
    fontWeight: 400,
  },
  pse: {
    marginRight: 0,
    marginLeft: -10,
  },
  formControl: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
});

export function ViewPaymentMethods(props) {
  const user = useSelector(SELECTOR_USER);
  const creditCardsId = useSelector(SELECTOR_CREDIT_CARD_SELECTED);

  const [PSE, setPSE] = useState({
    bank: '',
    type: 'CC',
    dni: '',
    cell_phone: '',
  });
  const [paymentMethod, setPaymentMethod] = useState('');
  const [disabledPayment, setDisabledPayment] = useState(true);

  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    if (paymentMethod === '') {
      setDisabledPayment(true);
      return;
    } else if (paymentMethod === 'credit-card' && !creditCardsId) {
      setDisabledPayment(true);
      return;
    } else if (
      paymentMethod === 'pse' &&
      (PSE.bank === '' || PSE.type === '' || PSE.dni === '')
    ) {
      setDisabledPayment(true);
      return;
    }

    setDisabledPayment(false);
  }, [paymentMethod, creditCardsId, PSE]);

  useEffect(() => {
    setPSE({
      ...PSE,
      cell_phone: user.phone || '',
      dni: user.dni || '',
    });
  }, [user.phone, user.dni]);

  const handlePay = async () => {
    setDisabledPayment(true);

    switch (paymentMethod) {
      case 'credit-card':
        if (!creditCardsId) {
          dispatch(
            addNotification('Selecciona un tarjeta de credito', 'error'),
          );
          setDisabledPayment(false);
          return;
        }
        try {
          const processPay = await api.customPayments.create({
            type: 'wallet',
            amount: Number(props.value.replace(/\D/gi, '')),
            method: 'credit_card',
            credit_card_id: creditCardsId,
            dues: 5,
          });

          // Codigos de respuesta segun docs de EPayco
          let success = [1, 3, 7, 8];
          if (success.includes(processPay.payment_status)) {
            await dispatch(getTotalEWallet());
            await dispatch(getEWallet());
            await dispatch(getCustomPayments());
            props.handleClose();
          } else {
            dispatch(addNotification(processPay.response.response, 'error'));
          }
        } catch (e) {
          dispatch(addNotification(e.message, 'error'));
        } finally {
          setDisabledPayment(false);
        }
        return;
      case 'pse':
        const respPSE = await api.customPayments.create({
          type: 'wallet',
          amount: Number(props.value.replace(/\D/gi, '')),
          method: 'pse',
          bank_id: PSE.bank,
          doc_type: PSE.type,
          doc_number: PSE.dni,
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          cell_phone: PSE.cell_phone,
        });
        if (!respPSE.success) {
          dispatch(addNotification(respPSE.text_response, 'error'));
          setDisabledPayment(false);
          return;
        }
        setDisabledPayment(false);
        window.open(respPSE.data.urlbanco, '_self');
        return;
      default:
        setDisabledPayment(false);
        return;
    }
  };

  return (
    <Box my={3} px={4}>
      <Typography className={classes.subtitle} color="textPrimary">
        Método de pago
      </Typography>
      <RadioGroup
        aria-label="payment-method"
        name="payment"
        value={paymentMethod}
        onChange={(e) => setPaymentMethod(e.target.value)}
      >
        <FormControlLabel
          value="credit-card"
          control={<AppRadio color="default" />}
          label={
            <Box display="flex" alignItems="center">
              <Box clone mr={1}>
                <PayIcon />
              </Box>
              Tarjeta de credito
            </Box>
          }
        />
        {paymentMethod === 'credit-card' && <ViewPaymentMethodCreditCards />}
        <FormControlLabel
          value="pse"
          control={<AppRadio color="default" />}
          label={
            <Box display="flex" alignItems="center">
              <img src={Pse} alt="PSE" className={classes.pse} />
              pse
            </Box>
          }
        />
        {paymentMethod === 'pse' && (
          <ViewPaymentMethodPSE PSE={PSE} setPSE={setPSE} />
        )}
      </RadioGroup>
      <Box display="flex" mt={2} justifyContent="flex-end">
        <AppButton
          color="secondary"
          round
          disableElevation
          variant="contained"
          onClick={handlePay}
          {...(disabledPayment ? { disabled: true } : {})}
        >
          Pagar
        </AppButton>
      </Box>
    </Box>
  );
}
